import { DWTablePrintTag } from 'src/components/table-print-tag';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWTablePrintTag.displayName, DWTablePrintTag);
export default DWTablePrintTag;
export { DWTablePrintTag };
